import React from 'react';

const TemplateExamples = ({ onLoadExample }) => {
    const examples = [
        {
            id: 'standard',
            name: 'Standard Professional',
            description: 'Formal and professional cover letter suitable for corporate roles',
            icon: 'fas fa-briefcase',
            color: 'from-blue-500 to-blue-700'
        },
        {
            id: 'creative',
            name: 'Creative & Modern',
            description: 'Bold and creative tone for design, marketing, and creative roles',
            icon: 'fas fa-palette',
            color: 'from-purple-500 to-pink-500'
        }
    ];

    return (
        <div className="bg-white rounded-xl p-5 shadow-md">
            <h3 className="font-bold text-gradpath-dark text-lg mb-4 flex items-center gap-2">
                <i className="fas fa-file-alt text-gradpath-green"></i> Templates & Examples
            </h3>
            <p className="text-sm text-gray-600 mb-4">
                Load an example to get started, then customize it to make it your own.
            </p>
            
            <div className="grid md:grid-cols-2 gap-4">
                {examples.map(example => (
                    <div key={example.id} 
                         className={`bg-gradient-to-r ${example.color} rounded-xl p-4 text-white cursor-pointer transform transition-all hover:scale-105 hover:shadow-lg`}
                         onClick={() => onLoadExample(example.id)}>
                        <i className={`${example.icon} text-3xl mb-3 block`}></i>
                        <h4 className="font-bold text-lg mb-1">{example.name}</h4>
                        <p className="text-sm text-white/90 mb-3">{example.description}</p>
                        <button className="bg-white/20 hover:bg-white/30 px-3 py-1 rounded-lg text-sm transition-all">
                            Load Example <i className="fas fa-arrow-right ml-1"></i>
                        </button>
                    </div>
                ))}
            </div>
            
            <div className="mt-4 p-3 bg-blue-50 rounded-lg">
                <p className="text-xs text-blue-800">
                    <i className="fas fa-lightbulb mr-1"></i>
                    <strong>Tip:</strong> Personalize your cover letter for each job application. 
                    Research the company and mention specific projects or values that align with your experience.
                </p>
            </div>
        </div>
    );
};

export default TemplateExamples;